// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__t_2cc","header":"Messages_header__2JdOx"};